module.exports = __webpack_public_path__ + "static/media/kinisthetic-icon@2x.a9741629.png";